import type { Course } from "@brookbush/types";

import {
	AudioWaveformIcon,
	BookCheckIcon,
	LibraryIcon,
	MessagesSquareIcon,
} from "lucide-react";

import AppBar from "~/components/AppBar";
import type { IAppBarItem } from "~/components/AppBar/AppBar";

type Props = {
	hasAudio?: boolean;
	course: Course;
};

const CourseAppBar = ({ hasAudio }: Props) => {
	const items = [
		{
			label: "Exams",
			icon: BookCheckIcon,
			onClick: () => {
				document.getElementById("exam-portal-button")?.click();
			},
		},

		hasAudio
			? {
					label: "Listen",
					icon: AudioWaveformIcon,
					onClick: () => {
						document.getElementById("audio-player-button")?.click();
					},
				}
			: undefined,

		{
			label: "Related",
			icon: LibraryIcon,
			href: "#related-courses",
		},

		{
			label: "Comments",
			icon: MessagesSquareIcon,
			href: "#course-comments",
		},
	].filter(Boolean) as IAppBarItem[];

	return <AppBar items={items} />;
};

export default CourseAppBar;
